import PageTransition from '../components/PageTransition';
import ScrollReveal from '../components/ScrollReveal';
import { useSEO } from '../hooks/useSEO';
import { PAGE_SEO } from '../utils/seo';

export default function TermsPage() {
  // Apply SEO
  useSEO(PAGE_SEO.terms);

  return (
    <PageTransition>
      <div className="container" style={{ maxWidth: '800px', paddingTop: 'var(--space-8)', paddingBottom: 'var(--space-12)' }}>
        <ScrollReveal>
          <header style={{ marginBottom: 'var(--space-10)' }}>
            <h1 className="h-1" style={{ marginBottom: 'var(--space-4)' }}>Terms & Conditions</h1>
            <p className="body-lg" style={{ color: 'var(--text-secondary)' }}>
              Last updated: April 13, 2026
            </p>
          </header>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-2" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Agreement to Terms</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.8, marginBottom: 'var(--space-4)' }}>
              By accessing or using the Siak Studios website ("Site") and engaging with our services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access the Site or use our services.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-warning)' }}>Services Description</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Siak Studios provides digital product development services including, but not limited to:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Mobile application development (iOS and Android)</li>
              <li>Web application and website design and development</li>
              <li>Brand identity and logo design</li>
              <li>UI/UX design and consulting</li>
              <li>Reddit community branding and design</li>
              <li>Desktop application development</li>
            </ul>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Project Engagement</h2>
            
            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Proposals and Quotes</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              All project proposals and quotes provided by Siak Studios are valid for 30 days from the date of issue. Final project scope, timeline, and pricing will be determined through mutual agreement and documented in a project agreement.
            </p>

            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Payment Terms</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Payment terms will be specified in individual project agreements. Unless otherwise stated:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>A deposit may be required before work commences</li>
              <li>Payments are due within the timeframe specified in invoices</li>
              <li>Late payments may incur additional charges</li>
            </ul>

            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Project Timeline</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Project timelines are estimates based on the information available at the time of proposal. Actual delivery dates may vary depending on:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Timeliness of client feedback and approvals</li>
              <li>Changes to project scope or requirements</li>
              <li>Complexity and technical challenges encountered</li>
              <li>Availability of required client-provided assets or information</li>
            </ul>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-announcement)' }}>Intellectual Property</h2>
            
            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Client Ownership</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Upon full payment, clients receive ownership of the final delivered work product, including:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Final application code or compiled assets</li>
              <li>Design files and brand guidelines (as specified in the project agreement)</li>
              <li>Documentation and deployment instructions</li>
            </ul>

            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Studio Rights</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Siak Studios retains the right to:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Display completed work in our portfolio and marketing materials</li>
              <li>Use general techniques, concepts, and learnings developed during the project</li>
              <li>Retain copies of work for archival and backup purposes</li>
            </ul>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Revisions and Changes</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              The number of revision rounds included in a project will be specified in the project agreement. Additional revisions or changes beyond the agreed scope may incur additional charges and/or timeline extensions.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-warning)' }}>Warranties and Limitations</h2>
            
            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Our Warranty</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Siak Studios warrants that:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Services will be performed in a professional and workmanlike manner</li>
              <li>Delivered products will conform to the specifications agreed upon in the project agreement</li>
              <li>We have the right to grant ownership of the delivered work</li>
            </ul>

            <h3 className="h-4" style={{ marginBottom: 'var(--space-3)', marginTop: 'var(--space-6)' }}>Limitation of Liability</h3>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Siak Studios shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use our services or delivered products. Our total liability shall not exceed the amount paid by the client for the specific service giving rise to the claim.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-announcement)' }}>Confidentiality</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Both parties agree to maintain confidentiality regarding proprietary information shared during the project. Siak Studios will not disclose confidential client information to third parties without explicit consent, except as required by law.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Termination</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Either party may terminate a project engagement with written notice. Upon termination:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li>Client shall pay for all work completed up to the termination date</li>
              <li>Siak Studios shall deliver all work-in-progress and completed work</li>
              <li>Both parties shall fulfill any outstanding payment or delivery obligations</li>
            </ul>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-warning)' }}>Post-Launch Support</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Every project includes a post-launch support period as specified in the project agreement. This typically includes bug fixes and minor adjustments. Major feature additions, platform updates, or ongoing maintenance require a separate support agreement.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Governing Law</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              These Terms shall be governed by and construed in accordance with applicable international commercial law. Any disputes arising from these terms shall be resolved through good-faith negotiation.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--text-announcement)' }}>Changes to Terms</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              Siak Studios reserves the right to modify these Terms at any time. Changes will be effective immediately upon posting to this page. Your continued use of the Site after changes constitutes acceptance of the modified terms.
            </p>
          </section>
        </ScrollReveal>

        <ScrollReveal>
          <section style={{ marginBottom: 'var(--space-8)' }}>
            <h2 className="h-3" style={{ marginBottom: 'var(--space-4)', color: 'var(--accent-green)' }}>Contact Information</h2>
            <p className="body" style={{ color: 'var(--text-near-white)', lineHeight: 1.7, marginBottom: 'var(--space-4)' }}>
              For questions about these Terms & Conditions, please contact us:
            </p>
            <ul style={{ paddingLeft: 'var(--space-6)', marginBottom: 'var(--space-4)', color: 'var(--text-near-white)', lineHeight: 1.7 }}>
              <li><strong style={{ color: 'var(--text-near-white)' }}>Email:</strong> <a href="mailto:hello@siak.in" style={{ color: 'var(--accent-green)' }}>hello@siak.in</a></li>
              <li><strong style={{ color: 'var(--text-near-white)' }}>Website:</strong> <a href="https://siak.in/contact" style={{ color: 'var(--accent-green)' }}>siak.in/contact</a></li>
            </ul>
          </section>
        </ScrollReveal>
      </div>
    </PageTransition>
  );
}
